import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { fetchActivePropertiesForSale } from "../../Redux/Actions/actions";
import { filtersToSearchParams } from "../../utils/propertyCatalogFilters";
import Card from "../Card/Card";
import Pagination from "../Pagination/Pagination";
import style from "./CardsContainerForSale.module.css";
import carga from "../../Assets/carga.gif";
import title from '../../Assets/titulo.png';
import AOS from "aos"; // Importar AOS
import "aos/dist/aos.css"; // Importar estilos de AOS

const CardContainer = ({ filters = {} }) => {
  const dispatch = useDispatch();
  const [, setSearchParams] = useSearchParams();
  const properties = useSelector((state) => state.properties);
  const totalPages = useSelector((state) => state.totalPages);
  const currentPage = useSelector((state) => state.currentPage);
  const error = useSelector((state) => state.error);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 450, easing: "ease-out-cubic", once: true, offset: 60 });
  }, []);

  useEffect(() => {
    setIsLoading(true);
    dispatch(fetchActivePropertiesForSale(filters, filters.page || 1)).then(() => {
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(filters)]);

  const handlePageChange = (page) => {
    setSearchParams(filtersToSearchParams(filters, { page })); // Mantiene los filtros al cambiar de página
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (isLoading) {
    return (
      <div className={style.containerCarga}>
        <img className={style.carga} src={carga} alt="Cargando..." />
      </div>
    );
  }

  if (error || properties.length === 0) {
    return <div className={style.containerError}>
      <img className={style.img} src={title} alt="byraices" />
      <p className={style.errorMessage}>
        NO SE ENCONTRARON
        <span className={style.highlight}> PROPIEDADES </span>
        DISPONIBLES
      </p>
    </div>;
  }
  return (
    <div>
      <div className={style.cardsContainer}>
        {properties.map((property, index) => (
          <div key={property.id} data-aos="fade-up" data-aos-delay={(index % 4) * 60}>
            <Card
              id={property.id}
              photo={property.photo}
              price={property.price}
              currency={property.currency}
              expenses={property.expenses}
              currencyExpenses={property.currencyExpenses}
              totalSquareMeters={property.totalSquareMeters}
              coveredSquareMeters={property.coveredSquareMeters}
              environments={property.environments}
              bathrooms={property.bathrooms}
              title={property.title}
              sellerId={property.sellerId}
              martillerId={property.martillerId}
              services={property.services}
              street={property.street}
              number={property.number}
              country={property.country}
              province={property.province}
              departments={property.departments}
              locality={property.locality}
            />
          </div>
        ))}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default CardContainer;